import { render } from "./HomePage1.vue?vue&type=template&id=4b47777d&scoped=true"
import script from "./HomePage1.vue?vue&type=script&lang=js"
export * from "./HomePage1.vue?vue&type=script&lang=js"

import "./HomePage1.vue?vue&type=style&index=0&id=4b47777d&lang=less&scoped=true"

import exportComponent from "D:\\project\\famousBuild\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b47777d"]])

export default __exports__